var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M506.3,66.9c-5.7-13.4-15.1-24.8-27-32.8c-6-4-12.5-7.2-19.6-9.4c-7-2.2-14.5-3.4-22.2-3.4H224c-10.3,0-20.1,2.1-29.1,5.9 c-13.4,5.7-24.8,15.1-32.8,27c-4,6-7.2,12.5-9.4,19.6c-2.2,7-3.4,14.5-3.4,22.2v53.3c0,11.8,9.6,21.3,21.3,21.3 c11.7,0,21.4-9.5,21.4-21.3V96c0-4.5,0.9-8.6,2.5-12.4c2.4-5.7,6.5-10.6,11.6-14.1c2.6-1.7,5.4-3.1,8.4-4s6.2-1.4,9.5-1.4h213.3 c4.5,0,8.6,0.9,12.4,2.5c5.7,2.4,10.6,6.5,14.1,11.6c1.7,2.6,3.1,5.4,4,8.4c0.9,3,1.4,6.2,1.4,9.5v320c0,4.5-0.9,8.6-2.5,12.4 c-2.4,5.7-6.5,10.6-11.6,14.1c-2.6,1.7-5.4,3.1-8.4,4c-3,0.9-6.2,1.4-9.5,1.4H234.7c-4.5,0-9.8-1-15.1-2.9c-4-1.4-7.9-3.4-11.4-5.8 c-5.3-3.5-9.7-7.8-12.3-11.9c-1.4-2.1-2.3-4.1-2.9-6c-0.6-1.9-0.9-3.7-0.9-5.5v-53.3c0-11.8-9.6-21.3-21.3-21.3 c-11.7,0-21.3,9.6-21.3,21.3v53.3c0,5.8,0.9,11.4,2.4,16.7c2.7,9.3,7.3,17.4,13,24.4c4.3,5.3,9.2,9.9,14.5,14 c7.9,6.1,16.8,10.9,26.1,14.3c9.4,3.4,19.2,5.3,29.3,5.3h202.7c10.3,0,20.1-2.1,29.1-5.9c13.4-5.7,24.8-15.1,32.8-27 c4-6,7.2-12.5,9.4-19.6c2.2-7,3.4-14.5,3.4-22.2V96C512.2,85.7,510.1,75.9,506.3,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M283.6,347.6c-8.3,8.3-8.3,21.8,0,30.2c8.3,8.3,21.8,8.3,30.2,0l106.7-106.7c4-4,6.2-9.5,6.2-15.1c0-5.6-2.3-11.1-6.2-15.1 L313.8,134.2c-8.3-8.3-21.8-8.3-30.2,0c-8.3,8.3-8.3,21.8,0,30.2l70.3,70.3H21.3C9.6,234.7,0,244.2,0,256s9.6,21.3,21.3,21.3h332.6 L283.6,347.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/SignIn.e34ddd103bb8d11755c10519722c991a.svg";
export { ForwardRef as ReactComponent };